import { Component, OnInit, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';
@Component({
  selector: 'show-errors',
  templateUrl: 'show-errors.component.html',
  styleUrls: ['show-errors.component.css'],
})
export class ShowErrorsComponent {
  private static readonly errorMessages: any = {
    'required': () => `This field is required`,
    'minlength': (type: any, params: any) => `The min number of characters is ` + params.requiredLength,
    'maxlength': (type: any, params: any) => `The max allowed number of characters is ` + params.requiredLength,
    'pattern': (type: any, params: any) => `Required pattern is ` + params.requiredPattern,
    'email': () => `Valid email is required!.`,
    'notMatch': (type: any, params: any) => `This field is not match ` + params.requiredPattern,
  };
@Input()cssClass: string = ''

  @Input()
  private control: AbstractControlDirective | AbstractControl | any;
  shouldShowErrors(): boolean {
    return this.control &&
      this.control.errors &&
      (this.control.dirty || this.control.touched);
  }

  listOfErrors(): string[] {
    return Object.keys(this.control.errors)
      .map(field => {
        return this.getMessage(field, this.control.errors[field])
      });
  }

  private getMessage(type: string, params: any) {
    return ShowErrorsComponent.errorMessages[type](type, params);
  }

}